import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Button from 'react-bootstrap/Button';
import { GoChevronRight } from "react-icons/go";
import { Container } from 'react-bootstrap';

function HomeSlide() {
  const [isHovered, setIsHovered] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(0);

  const handleImageLoad = () => {
    setImagesLoaded(imagesLoaded + 4);
  };
  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  const captionStyle = {
    position: "absolute",
    top: "50%",
    left: "2%", // Adjusted left position for left alignment
    transform: "translate(20%, -20%)",
    textAlign: "left",
    color: "white",
    maxWidth: "925px",
    flex: "0 0 auto",
    gap: "10px",
    padding: "10px",
  };


  const imageStyle = {
    objectFit: "cover",
    filter: "opacity(1) brightness(1)",
  };
 
  
  const buttonStyle = {
    fontSize: '16px',
    fontWeight: 600,
    marginTop:'1px',
    border: 'none',
    backgroundColor: isHovered ? '#F7F9FF' : '#FFE114',
    color: isHovered ? 'black' : 'black',
    transition: 'background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s',
    transform: isHovered ? 'translateX(10px)' : 'translateX(0)',
  };
  
  const mobileCaptionButtonStyle = {
    backgroundColor: '#FFE114',
    fontSize: '12px',
    fontWeight: 400,
    color: "black",
    marginTop:'-2px',
    padding: '1px',
};

 
 
  return (
    <Container fluid style={{ margin: '-8px 0 0 0', padding: 0 }}>
      <Carousel  fade>
      <Carousel.Item >
    <img
      src={process.env.PUBLIC_URL + "/assets/images/Banner1.png"}
      className="d-block w-100"
      alt=""
      style={imageStyle}
      onLoad={handleImageLoad}
    />
          <Carousel.Caption style={captionStyle} >
            <h3 className='captionTextStyleHome'>Local Talent, Global Impact</h3>
            <p className="captionTextStyleHomep">
                Recruit Emirati and Saudi Talent to Elevate Your Business Success
            </p>
          <span className="d-none d-sm-block">
            <div style={{marginTop:'50px'}}>
            <Button
            // className='animated-imaget'
              margin={5}
              padding={5}
              variant="warning"
              size="lg"
              active
              style={{mobileCaptionButtonStyle, ...buttonStyle}}
              href="/ContactUs" // Add the desired URL here
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >&nbsp;&nbsp;
              Contact Us{" "}&nbsp;&nbsp;
              <span style={{ fontSize: "20px" }}>
                <GoChevronRight />
              </span>&nbsp;&nbsp;
            </Button>{" "}
            </div>
            </span>
          </Carousel.Caption>
        </Carousel.Item>
        
        <Carousel.Item>
          <img
            src={process.env.PUBLIC_URL + "/assets/images/Banner2.png"}
            className="d-block w-100"
            alt=""
            style={imageStyle}
            onLoad={handleImageLoad}
          />
          <Carousel.Caption style={captionStyle}>
            <h3 className='captionTextStyleHome'>Leadership Redefined</h3>
            <p className="captionTextStyleHomep">
              Discover Leaders Who Revolutionize Your Business Landscape
            </p>
          <span className="d-none d-sm-block">
            <div style={{marginTop:'50px'}}>
            <Button
            // className='animated-imaget'
              variant="warning"
              size="lg"
              active
              style={{mobileCaptionButtonStyle, ...buttonStyle}}
              href="/ContactUs" // Add the desired URL here
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >&nbsp;&nbsp;
              Contact Us{" "}&nbsp;&nbsp;
              <span style={{ fontSize: "20px" }}>
                <GoChevronRight />
              </span>&nbsp;&nbsp;
            </Button>{" "}
            </div>
            </span>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src={process.env.PUBLIC_URL + "/assets/images/Banner3.png"}
            className="d-block w-100"
            alt=""
            style={imageStyle}
            onLoad={handleImageLoad}
          />
          <Carousel.Caption style={captionStyle}>
            <h3 className='captionTextStyleHome'>
              Skill Up, Rise Up
            </h3>
            <p className="captionTextStyleHomep">
              Empower Your Workforce with Our Tailor-made Training Courses
            </p>
          <span className="d-none d-sm-block">
            <div style={{marginTop:'50px'}}>
            <Button
            // className='animated-imaget'
              margin={5}
              padding={5}
              variant="warning"
              size="lg"
              active
              style={{mobileCaptionButtonStyle, ...buttonStyle}}
              href="/ContactUs" // Add the desired URL here
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >&nbsp;&nbsp;
              Contact Us{" "}&nbsp;&nbsp;
              <span style={{ fontSize: "20px" }}>
                <GoChevronRight />
              </span>&nbsp;&nbsp;
            </Button>{" "}
            </div>
            </span>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            src={process.env.PUBLIC_URL + "/assets/images/Banner4.png"}
            className="d-block w-100"
            alt=""
            style={imageStyle}
            onLoad={handleImageLoad}
          />
          <Carousel.Caption style={captionStyle}>
            <h3 className='captionTextStyleHome'>Connecting Expertise, Crafting Success</h3>
            <p className="captionTextStyleHomep">
              Bring World-class Skilled Professionals Right to Your Doorstep
            </p>
          <span className="d-none d-sm-block">
            <div style={{marginTop:'50px'}}>
            <Button
            // className='animated-imaget'
              margin={5}
              padding={5}
              variant="warning"
              size="lg"
              active
              style={{mobileCaptionButtonStyle, ...buttonStyle}}
              href="/ContactUs" // Add the desired URL here
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >&nbsp;&nbsp;
              Contact Us{" "}&nbsp;&nbsp;
              <span style={{ fontSize: "20px" }}>
                <GoChevronRight />
              </span>&nbsp;&nbsp;
            </Button>{" "}
            </div>
            </span>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
      {/* Show the carousel arrows only when all images are loaded */}
      {imagesLoaded === 4 ? (
        <div>
          {/* Your arrow components or any other controls */}
        </div>
      ) : null}
    </Container>
  );
}
 
export default HomeSlide;
 